import { Component, signal } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from '../../../core/services';

@Component({
    selector: 'app-loader',
    standalone: true,
    imports: [MatProgressSpinnerModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {

  loading= signal<boolean>(false);

  constructor(private loaderService: LoaderService) { 
    this.loaderService.isLoading.subscribe((value) => {
      this.loading.set(value);
    });
  }

}
